export default __webpack_public_path__ + "static/media/business-problem5.3b85f228.png";